import React from 'react';

export interface SkeletonRootProps {
  loadingLabel: string;
  children: React.ReactNode;
  className?: string;
}

const SkeletonRoot: React.FC<SkeletonRootProps> = ({
  loadingLabel,
  children,
  className = '',
}) => (
  <div className={className} aria-busy="true" aria-live="polite">
    <span className="sr-only">{loadingLabel}</span>
    <div aria-hidden="true">{children}</div>
  </div>
);

export default SkeletonRoot;
